import axios from "axios";

import ENV from "../../../../util/env-config";

class Service {
  static answerCheckin(requestData) {
    return axios.post(ENV.kioskBase + "/checkin/answer", requestData);
  }
}

export default Service;
